import {
  CallSessionService,
  UsersService,
  InstitutionsService,
} from '../../services';
import { store } from '../../stores/redux/store';
import { getLogger } from '../../libs/logger';

export const callSessionService = new CallSessionService<typeof store>({
  store,
  logger: getLogger('CallSessionService'),
});

export const usersService = new UsersService<typeof store>({
  store,
  logger: getLogger('UsersService'),
});

export const institutionsService = new InstitutionsService<typeof store>({
  store,
  logger: getLogger('InstitutionsService'),
});
